define('models/calendar/nutrition/food-favorite',[
    'underscore', 'backbone', 'utils',
    // services
    'services/api',
    // models
    'models/calendar/nutrition/food',
    'collections/calendar/nutrition/servings'
], function(
    _, Backbone, U, API,
    // models
    MFood,
    CServings
) {

    var MFoodFavorite = MFood.extend({
        idAttribute: 'id',
        urlRoot: function() {
            var url = "nutrition/favorites/";
            if (this.isNew()) url += this.get('type') + '/';
            return API.url(url);
        },

        parse: function(data, options) {
            if (data.food) data.name = data.food.name;
            return MFoodFavorite.__super__.parse.apply(this, [data, options]);
        },

        initialize: function(attrs, options) {
            this.listenTo(this, { 'change:food': this.onFoodChange });
        },

        getFood: function() {
            this._createFood();
            return this.food;
        },

        setFood: function(attrs, options) {
            return this.set({ food: attrs }, options);
        },

        getFoodId: function() {
            return this.get('foodId');
        },

        getServings: function() {
            var food = this.get('food');
            if (food) return new CServings(food.servings);
        },

        getType: function() {
            return this.get('type');
        },

        isFavorite: function() {
            return true;
        },

        isEditable: function() {
            return this.isCustom();
        },

        isCustom: function() {
            return this.getType() === "customFood";
        },

        _createFood: function() {
            if (!this.food) {
                this.food = new MFood(this.get('food'));
                // this.listenTo(this.food, { 'change': this.onFoodModelChange });
            }
        },

        ////////////
        // events //
        ////////////
        onFoodChange: function(model, value, options) {
            if (this.food) this.food.reset(value);
        },
        // onFoodModelChange: function() {
        //
        // },

    }, {
        createFromFood: function(attrs) {
            return new MFoodFavorite({
                food: attrs
            });
        }
    });

    return MFoodFavorite;
});

